<template>
  <div class="download-page container page">
    <h1 class="page-title">下载中心</h1>

    <div class="download-list">
      <div
        class="download-item"
        v-for="(item, index) in downloads"
        :key="index"
      >
        <div class="download-left">
          <img :src="item.icon" :alt="item.title" />
        </div>
        <div class="download-right">
          <div class="download-info">
            <h3>{{ item.title }}</h3>
            <p class="desc">{{ item.desc }}</p>
          </div>
          <div class="download-actions">
            <el-button
              type="primary"
              size="small"
              @click="downloadFile(item.file)"
            >
              下载
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
  data() {
    return {
      downloads: [
        {
          title: "Zbeacon网关工具V1.0.16",
          desc: "用于配置网关参数的桌面工具，支持 Windows。",
          icon: require("@/assets/images/download/tool.png"),
          file: "Zbeacon网关工具V1.0.16.zip",
        },
        {
          title: "Zbeacon新设备接入快速入门v1.0",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "Zbeacon新设备接入快速入门v1.0.pdf",
        },
        // {
        //   title: "Zigbee 固件升级包",
        //   desc: "最新 Zigbee 3.0 固件，支持 OTA 升级。",
        //   icon: require("@/assets/images/download/firmware.png"),
        //   file: "zigbee_firmware.bin",
        // },
        {
          title: "LittleScene_2.0.1_202510261836",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "LittleScene_2.0.1_202510261836.zip",
        },
        {
          title: "Zbhome开发板",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "Zbhome开发板.pdf",
        },
        {
          title: "Zbeacon Model Library Specification",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "Zbeacon Model Library Specification.pdf",
        },
        {
          title: "Zbeacon Specification",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "Zbeacon Specification.pdf",
        },
        {
          title: "zbeacon-gw01网关介绍",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "zbeacon-gw01网关介绍.docx",
        },
        {
          title: "zbeacon网关mqtt开发文档v1.1",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "zbeacon网关mqtt开发文档v1.1.pdf",
        },
        {
          title: "zbeacon网关SDK 引导",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "zbeacon网关SDK 引导.docx",
        },
        {
          title: "zbeacon网关tuya透传协议",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "zbeacon网关tuya透传协议.xlsx",
        },
        {
          title: "zbeacon网关基础上手入门",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "zbeacon网关基础上手入门.xlsx",
        },
        {
          title: "Zbeacon网关已支持Zigbee产品接入列表",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "Zbeacon网关已支持Zigbee产品接入列表.xlsx",
        },

        {
          title: "ZT3L 模组规格书",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "ZT3L 模组规格书.pdf",
        },
        {
          title: "ZTU 模组规格书",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "ZTU 模组规格书.pdf",
        },
        {
          title: "烨博智能-z.58.s6",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "烨博智能-z.58.s6.pdf",
        },
        {
          title: "烨博智能-ZT8L-PA",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "烨博智能-ZT8L-PA.pdf",
        },
        {
          title: "烨博智能-ZT8L",
          desc: "详细介绍系统功能与使用方法的 PDF 文档。",
          icon: require("@/assets/images/download/doc.png"),
          file: "烨博智能-ZT8L.pdf",
        },
      ],
    };
  },
  methods: {
    downloadFile(fileName) {
      const link = document.createElement("a");

      link.href = `${process.env.BASE_URL}downloads/${encodeURIComponent(
        fileName
      )}`;

      console.log(link.href);
      link.download = fileName; // ✅ 指定文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.download-page {
  padding: 40px 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 30px;
}

.download-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.download-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: all 0.3s;
}

.download-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.download-left {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.download-left img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.download-right {
  flex: 1;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.download-info {
  flex: 1;
}

.download-actions {
  margin-left: 20px;
  flex-shrink: 0;
}

.desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
